import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/system-registry/page.tsx");
